import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import { useRouter } from "next/router";

export interface JobListItem {
  name: string;
  location: string;
  status: string;
  date: string;
  id: string;
  fromRelated?: boolean
}

const JobListItem = ({ name, location, status, date, id, fromRelated = false }) => {
  const datePublished = new Date(date).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
  const router = useRouter();

  return (
    <button type="button" onClick={() => {
      if (fromRelated) {
        router.replace(`${id}`)
      } else {
        router.push(`careers/${id}`)
      }
    }}>
      <div className="flex flex-col border-b rounded-b-xl sm:flex-row pb-6 pt-4 md:px-5 justify-between w-full">
        <div className="p-2 flex justify-center sm:flex-none sm:justify-start">
          <p className="text-[#093E70] label-lg sm:label-md lg:subheading hover:cursor-pointer">
            {name}
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:gap-0 sm:flex sm:flex-row sm:space-x-3 label-sm text-text-color-high-em">
          <div className="bg-background-low-em rounded-lg flex flex-row items-center px-[14px] py-[8px]">
            <Icon path={mdiMapMarker} size={0.7} />
            <p className="ml-px">
              {location}
            </p>
          </div>
          <div className="bg-background-low-em rounded-lg flex items-center px-[14px] py-[8px]">
            {status && status.toUpperCase()}
          </div>
          <div className="bg-background-low-em rounded-lg flex items-center px-[14px] py-[8px]">
            {datePublished}
          </div>
        </div>
      </div>
    </button>

  );
};

export default JobListItem